import { AxiosResponse } from 'axios';
import ApiService from '../../Services/ApiService';
import { showMessage } from '../Toastr/ToastService';
import { getRequest } from '../../Services/HttpService';

export const ACTIVATE_ACCOUNT_ERROR = '[AUTH] ACTIVATE_ACCOUNT_ERROR';
export const ACTIVATE_ACCOUNT_SUCCESS = '[AUTH] ACTIVATE_ACCOUNT_SUCCESS';

const URL_ACTIVATE_ACCOUNT = 'v1/auth/create-password';
const URL_ACTIVATE_ACCOUNT_FORM = 'v1/auth/create-password';

const ActivateAccountService = {
  async getForm(token: string | undefined, language: string): Promise<any> {
    if (!token) {
      console.warn('Activation token is empty.');
      return null;
    }

    const response = await getRequest(`/v1/auth/create-password/${token}?language=${language}`, {
      noAuthHeader: true,
      returnAxioErrorResponseData: true,
      showErrorToaster: false,
      showToaster: false,
    });

    if (response) {
      return response;
    }
    return false;
  },

  async submitForm(
    token: string,
    password: string,
    confirmPassword: string
  ): Promise<AxiosResponse | false> {
    const response = await ApiService.post(`${URL_ACTIVATE_ACCOUNT}/${token}`, {
      password,
      confirm_password: confirmPassword,
    });

    if (response && response.data) {
      if (response.data.status === 'error' && response.data.toast) {
        showMessage('', response.data.toast.message, response.data.toast.type.toLowerCase());
      }
      return response.data;
    }
    return false;
  },

  async signtryToLoadFormIn(token: string) {
    return (): ApiService => {
      return ApiService.get(`${URL_ACTIVATE_ACCOUNT_FORM}/${token}`, null);
    };
  },
};

export default ActivateAccountService;
